<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <div id="formTable">
      <div id="text">运输任务列表</div>
      <div id="ddas">
        <!-- <Button @click="reOpenWin" type="primary" size="small" icon="md-cloud-download">导出</Button>-->
        <Button @click="openAdd" type="primary" size="small" icon="md-add"
          >新增</Button
        >
      </div>
    </div>

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
    >
     
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增运输任务' : '编辑运输任务'"
      ref="formModel"
      :labelWidth="100"
      width="1100"
    >
      <tableForm
        noAdd
        slot="transportGoodsList"
        :forms="transportGoodsListForm"
        :item1="transportGoodsListItem"
        v-model="item.transportGoodsList"
      >
        <Button slot="btn" @click="getOrdersList">重新获取货物单</Button>
      </tableForm>
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
  </div>
</template>
<script>
import addressList from "./addressList.vue";
export default {
  components: { addressList },
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "操作",
          slot: "action",
          width: 130,
          align: "center",
          fixed: "right",
        },
      ],
      tableData: [],
      item: {
        groupId: "",
        groupName: "",
        ono: "",
        transportGoodsList: [],
        customer: null,
        carNo: "粤B668",
        driverId: "1629855227066994689",
        driver: "赵六",
        tradeMode: "出口",
        serviceType: "全线直达",
        addressS: "广州",
        timeS: 1680747397000,
        addressD: "香港",
        timeD: 1680747415000,
        dispatcher: null,
        dispatcherId: null,
        filePath: null,
        remark: null,
        extendFields: null,
        yd: 0,
        xs: 0,
        ys: 0,
        xd: 0,
      },
      item1: {
        xd: 0,
        xs: 0,
        yd: 0,
        ys: 0,
        groupId: "",
        no: "",
        ono: "",
        customer: "",
        carNo: "",
        driverId: "",
        driver: "",
        tradeMode: "",
        serviceType: "",
        transportGoodsList: [
          /* {
            pnumber: 0,
            id: 0,
            name: "",
            barCode: "",
            volume: 0,
            model: "",
            amount: 0,
            weight: 0,
            imgPath: "",
            remark: "",
            keyWork: "",
            idList: [],
          }, */
        ],
        addressS: "",
        timeS: "",
        addressD: "",
        timeD: "",
        status: 0,
        filePath: "",
        remark: "",
        extendFields: "",
      },
      forms: [
        {
          title: "订单号",
          key: "ono",
          type: "Select",
          selectItems: [],
          required: true,
          span: 8,
        },
        {
          title: "单位名称",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
          required: true,
          span: 8,
        },
        {
          title: "任务状态",
          key: "status",
          key2: "status2",
          st: "taskStatus1",
          type: "Select1",
          span: 8,
        },
        {
          title: "服务类型",
          key: "serviceType",
          selectItems: ["国内段", "中港段", "香港段"],
          type: "Select",
          required: true,
          span: 8,
        },
        {
          title: "贸易方式",
          key: "tradeMode",
          selectItems: ["出口", "进口"],
          type: "Select",
          required: true,
          span: 8,
        },

        {
          title: "运输车辆",
          key: "carId",
          key1: "carNo",
          type: "selectCar",
          required: true,
          span: 8,
        },
        {
          title: "驾驶员",
          key: "driverId",
          key1: "driver",
          type: "selectDriver",
          required: true,
          span: 8,
        },
        {
          title: "提货地点",
          key: "addressS",
          keyX: "xs",
          keyY: "ys",
          type: "selectAddMap",
          span: 8,
        },
        {
          title: "提货时间",
          key: "timeS",
          key2: "timeS2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "送货地点",
          key: "addressD",
          keyX: "xd",
          keyY: "yd",
          type: "selectAddMap",
          span: 8,
        },
        {
          title: "送货时间",
          key: "timeD",
          key2: "timeD2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "附件",
          key: "filePath2",
          type: "lyPhoto",
          span: 8,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
          type1: "textarea",
          span: 8,
        },

        {
          title: "运输货物清单",
          key: "transportGoodsList",
          slot: "transportGoodsList",
          slotForm: "transportGoodsList",
          span: 24,
          required: true,
        },
      ],
      transportGoodsListForm: [
        {
          title: "名称",
          key: "name",
          type: "Input",
          required: true,
        },
        {
          title: "单位名称",
          key: "groupId",
          key1: "groupName",
          type: "selectGroup",
          required: true,
        },
        {
          title: "条码",
          key: "barCode",
          type: "Input",
          required: true,
        },
        {
          title: "型号",
          key: "model",
          type: "Input",
        },
        {
          title: "体积",
          key: "volume",
          type: "InputNumber",
          required: true,
        },
        {
          title: "件数",
          key: "amount",
          type: "InputNumber",
          required: true,
        },
        {
          title: "重量",
          key: "weight",
          type: "InputNumber",
          required: true,
        },
        {
          title: "备注信息",
          key: "remark",
          type: "Input",
        },
      ],
      transportGoodsListItem: {
        groupId: "",
        groupName: "",
        name: "手机",
        barCode: "cod2445",
        volume: 400,
        model: "华为P30",
        amount: 20,
        weight: 30,
        imgPath: null,
        remark: null,
        //pnumber: 300,
      },
      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      total: 0,
    };
  },
  methods: {
    getList() {
      
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/transport/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].status=String(data[i].status);
          data[i].status2=this.$t('taskStatus1.'+data[i].status);
          data[i].timeD2=this.utils.time(data[i].timeD,'yymmddhhmm');
          data[i].timeS2=this.utils.time(data[i].timeS,'yymmddhhmm');
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      console.log(this.item);
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/transport/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-ctc/transport/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-ctc/transport/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      console.log(this.item);
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    //carTypeCategory

    cols() {
      var b = JSON.parse(JSON.stringify(this.forms));
      //b.splice(2, 4);
      for (let i = 0; i < b.length; i++) {
        if (!b[i].minWidth && !b[i].maxWidth) {
          b[i].minWidth = 200;
          b[i].maxWidth = 300;
        }
        if (b[i].key1) {
          b[i].key = b[i].key1;
        }
        if (b[i].key2) {
          b[i].key = b[i].key2;
        }
      }
      this.columns.splice(1, 0, ...b);
      //a.splice.apply(a,[i,0].concat(b));//es5写法
    },
    getOrdersList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        var m = [];
        for (let i = 0; i < data.length; i++) {
          m = m.concat(data[i].ordersGoodsList);
        }
        for (let i = 0; i < this.forms.length; i++) {
          if (this.forms[i].key == "transportGoodsList") {
            //alert(this.forms[j].key)
            this.item[this.forms[i].key] = m;
          }
          if (this.forms[i].key == "ono") {
            this.forms[i].selectItems = [];
            for (let j = 0; j < data.length; j++) {
              this.forms[i].selectItems.push(data[j].no);
            }
          }
        }
      });
    },
    getOrdersInfo(no) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-omc/orders/infoNo",
        data: {no},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data=res.data.data;
        console.log(data);
      });
    },
  },
  mounted() {
    this.cols();
    this.getList();
    this.getOrdersList();
  },
  computed: {
    ono() {
      return this.item.ono;
    }
  },
  watch: {
    ono(v) {
      console.log(v);
      //this.getOrdersInfo(v);
    },
  },
};
</script>
<style>

</style>


// WEBPACK FOOTER //
// src/components/wuliu/yunshurenwu.vue